import { CheckCircle, CircleOutlined, MoreHoriz } from "@mui/icons-material";
import cx from "classnames";
import React from "react";
import styles from "./TimelineStep.module.scss";

export const TimelineStep = ({
	acteLegislatif,
	selectedActeUid,
	status,
	label,
	onClickStep,
}) => {
	const isSelected = acteLegislatif?.uid === selectedActeUid;

	return (
		<button
			className={cx(styles.step, styles[status], {
				[styles.selected]: isSelected,
			})}
			onClick={onClickStep}
			aria-label={label}
			type="button"
		>
			{status === "complete" && <CheckCircle className={styles.stepIcon} />}
			{status === "active" && <MoreHoriz className={styles.stepIcon} />}
			{status === "pending" && <CircleOutlined className={styles.stepIcon} />}
			<span>{label}</span>
		</button>
	);
};
